document.addEventListener('DOMContentLoaded', () => {
  const STORAGE_KEY = 'nked-helpful-votes';

  function getVotes() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || {};
    } catch (e) {
      return {};
    }
  }

  function saveVotes(votes) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(votes));
  }

  const votes = getVotes();

  document.querySelectorAll('[data-helpful-btn]').forEach((btn) => {
    const reviewId = btn.dataset.reviewId;
    const item = btn.closest('.nked-written__item');
    const countEl = item ? item.querySelector('[data-helpful-count]') : null;
    const baseCount = parseInt(btn.dataset.baseCount, 10) || 0;

    function render(count, voted) {
      if (!countEl) return;
      if (count > 0) {
        countEl.hidden = false;
        countEl.textContent = `${count} people found this helpful`;
      } else {
        countEl.hidden = true;
      }
      if (voted) {
        btn.setAttribute('data-voted', 'true');
      }
    }

    const alreadyVoted = Boolean(votes[reviewId]);
    render(baseCount + (alreadyVoted ? 1 : 0), alreadyVoted);

    btn.addEventListener('click', () => {
      if (votes[reviewId]) return;
      votes[reviewId] = true;
      saveVotes(votes);
      render(baseCount + 1, true);
    });
  });
});
